"use strict";

exports.__esModule = true;
exports.default = void 0;
var _getNative = _interopRequireDefault(require("./_getNative.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var defineProperty = function () {
  try {
    var func = (0, _getNative.default)(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();
var _default = exports.default = defineProperty;